import { statusTokens } from "../domain/status";
import type { CompanyStatus } from "../domain/status";
import { nl } from "../i18n/nl";

export interface StatusGlyphProps {
  status: CompanyStatus;
  /** Width in px; the glyph is 16×18. */
  size?: number;
  /** Announce the status (use when no text label is next to the glyph). */
  labelled?: boolean;
}

/**
 * The float ("dobber"): stem, circle with white fill and status-coloured rim, top half filled.
 * `tip` has a dotted rim and no fill. Every status has its own shape cue, never colour alone.
 */
export function StatusGlyph({ status, size = 16, labelled = false }: StatusGlyphProps) {
  const { glyph } = statusTokens(status);
  const isTip = status === "tip";
  const a11y = labelled
    ? { role: "img", "aria-label": nl.status[status] }
    : { "aria-hidden": true as const };
  return (
    <svg
      width={size}
      height={(size * 18) / 16}
      viewBox="0 0 16 18"
      focusable="false"
      data-status={status}
      {...a11y}
    >
      <line x1="8" y1="1" x2="8" y2="4.5" stroke={glyph} strokeWidth="1.5" strokeLinecap="round" />
      <circle
        cx="8"
        cy="11"
        r="5.25"
        fill="#ffffff"
        stroke={glyph}
        strokeWidth="1.5"
        strokeDasharray={isTip ? "2.2 1.8" : undefined}
      />
      {!isTip && <path d="M2.75 11a5.25 5.25 0 0 1 10.5 0Z" fill={glyph} />}
    </svg>
  );
}
